{
  "logoAlt": "Curipop",
  "tagline": "Simple, accurate answers for curious kids ages 5-12. Fueling curiosity, one question at a time.",
  "badges": {
    "coppa": "COPPA Compliant"
  },
  "sections": {
    "product": "Product",
    "families": "Families",
    "trust": "Trust & Company"
  },
  "links": {
    "allQuestions": "All Questions",
    "topics": "Topics",
    "pricing": "Pricing",
    "signIn": "Sign In",
    "kidLogin": "Kid Login",
    "forFamilies": "For Families",
    "comparePlans": "Compare Plans",
    "familyStories": "Family Stories",
    "dashboardPreview": "Dashboard Preview",
    "faq": "FAQ",
    "privacy": "Privacy Policy",
    "terms": "Terms of Service",
    "safety": "Safety & Trust",
    "forSchools": "For Schools",
    "about": "About Us",
    "accessibility": "Accessibility",
    "cookies": "Cookie Policy"
  },
  "labels": {
    "email": "Email us at hello@curipop.com"
  },
  "copyright": "© {year} Curipop. All rights reserved.",
  "madeWith": "Made with",
  "madeWithSuffix": "for curious kids everywhere"
}
